import { useMemo, useRef } from "react";
import messages from "./translations/messages";
import createTranslator from "../../../util/translationHelper";
import { useHistory } from "react-router-dom";

function useCard() {
  const history = useHistory();
  const lang = window?.localStorage?.getItem("lang") ?? "en";

  const translate = useMemo(() => {
    return createTranslator(messages);
  }, [createTranslator, messages]);

  return {
    translate,
    history,
    lang,
  };
}

const Hook = {
  useCard,
};

export default Hook;
